import qs from 'query-string';

import { PARAM_BLACKLIST } from '../urls/urlParamLists';

// Not yet used...
export function generateUrl(path: string, queryParams: any) {
  PARAM_BLACKLIST.forEach(
    blacklistedParam => delete queryParams[blacklistedParam],
  );

  return `${URL_BASE}${path}?${qs.stringify(queryParams)}`;
}

export function canonicalUrl(
  staticCanonicalPathname: string,
  adminPathname: string,
  defaultPathname: string,
) {
  if (typeof staticCanonicalPathname === 'string') {
    return staticCanonicalPathname;
  } else if (adminPathname.length) {
    return adminPathname;
  } else {
    return defaultPathname;
  }
}

export function titleCleaner(title1: string, title2: string) {
  return title1.length ? title1 : title2;
}
